import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AsyncStates } from 'src/constants'
import {
  conversationHistoryClear,
  createConversationClear,
  currentConversationClear,
  getConversationsRequest,
  getExtractionsClear
} from 'src/store/actions/polyGPT'
import { StoreState } from 'src/store/configureStore'
import { Col, Modal, Row, Space } from 'antd'
import { PlusOutlined } from '@ant-design/icons'
import './Gpt.scss'
import { GPTConversationList } from './components/GPTConversationList'
import { GptRightPanel } from './GptRigthPanel'
import { StyledPageHeader } from 'src/styled_components/StyledPageHeader'
import { StyledCard } from 'src/styled_components/StyledCard'
import useTranslate from 'src/utils/useTranslate'
import { StyledButton } from 'src/styled_components/StyledButton'

export const GptLogo = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="8" fill="#F0F0F0" />
      <g clipPath="url(#clip0_1461_1589)">
        <path
          d="M35.1398 27.2551C34.0759 27.2551 33.1486 27.8313 32.6556 28.6859L27.1442 26.0431C27.1398 25.4562 27.1422 24.8687 27.1422 24.2823V22.4346L30.7641 19.5871C30.769 19.592 30.7734 19.5969 30.7784 19.6017C31.7111 20.527 33.2232 20.527 34.156 19.6017C35.0887 18.6765 35.0887 17.1764 34.156 16.2511C33.2232 15.3258 31.7111 15.3258 30.7784 16.2511C29.9449 17.0779 29.8569 18.363 30.5125 19.2873L26.9117 22.1177C26.8375 22.0783 26.7658 22.0329 26.694 21.9895C26.4876 21.8647 26.2862 21.7321 26.0763 21.6132C25.8227 21.4699 25.5608 21.3416 25.3067 21.1993C25.0305 21.0443 24.7593 20.8814 24.487 20.7196C24.2565 20.5826 24.028 20.4417 23.7975 20.3042C23.7877 20.2984 23.7779 20.292 23.7685 20.2857V15.6949C25.5426 15.594 26.9496 14.1354 26.9496 12.3501C26.9496 10.5649 25.437 9 23.5715 9C21.706 9 20.1938 10.5 20.1938 12.3506C20.1938 14.2012 21.6008 15.594 23.3749 15.6954V20.314C23.1999 20.4105 23.0235 20.5051 22.8505 20.605C22.5704 20.7679 22.2962 20.9399 22.0166 21.1023C21.8023 21.2266 21.5802 21.3363 21.3669 21.4621C21.186 21.5688 21.017 21.6961 20.8356 21.8018C20.6292 21.9218 20.4179 22.0319 20.2081 22.1455L16.7091 19.3721C17.432 18.4429 17.3646 17.1038 16.5056 16.2521C15.5729 15.3268 14.0607 15.3268 13.128 16.2521C12.1952 17.1774 12.1952 18.6774 13.128 19.6027C14.0406 20.508 15.507 20.527 16.4437 19.6612L19.9982 22.4785C19.9997 23.6612 19.9992 24.8434 20.0022 26.0261L19.985 25.9924L13.9654 28.974C13.5875 28.37 12.9127 27.9678 12.1436 27.9678C10.9598 27.9678 10 28.9199 10 30.0943C10 31.2687 10.9598 32.2208 12.1436 32.2208C13.3275 32.2208 14.2873 31.2687 14.2873 30.0943C14.2873 29.8223 14.2352 29.5619 14.1413 29.3231L20.1526 26.3459C20.2287 26.3927 20.3083 26.4346 20.386 26.4794C20.6617 26.6389 20.9374 26.7992 21.2141 26.9567C21.418 27.0732 21.6254 27.1829 21.8283 27.3009C21.9561 27.3755 22.076 27.4637 22.2038 27.5393C22.5611 27.7518 22.9218 27.959 23.2791 28.1716C23.3105 28.1901 23.3425 28.2076 23.3749 28.2228V32.3061C21.6008 32.407 20.1938 33.8656 20.1938 35.6509C20.1938 37.4361 21.706 39.0015 23.5715 39.0015C25.437 39.0015 26.9491 37.5014 26.9491 35.6509C26.9491 33.8003 25.5421 32.4075 23.768 32.3061V28.2218C24.029 28.0863 24.2767 27.9249 24.5317 27.7791C24.7327 27.6646 24.9391 27.5598 25.1401 27.4452C25.3279 27.3384 25.5121 27.2248 25.6969 27.1127C25.8203 27.0376 25.9387 26.9528 26.066 26.8846C26.3697 26.7217 26.6778 26.5672 26.9825 26.4068C26.9845 26.4058 26.9864 26.4044 26.9884 26.4029L32.4836 29.0379C32.3514 29.3645 32.2777 29.7209 32.2777 30.0948C32.2777 31.6626 33.5589 32.9335 35.1394 32.9335C36.7198 32.9335 38.001 31.6626 38.001 30.0948C38.001 28.527 36.7198 27.256 35.1394 27.256L35.1398 27.2551Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_1461_1589">
          <rect width="28" height="30" fill="white" transform="translate(10 9)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const GptLogoV2 = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <rect width="40" height="40" rx="8" fill="#141414" />
      <g clip-path="url(#clip0_4711_76011)">
        <path
          d="M28.7527 22.604C27.9168 22.604 27.1881 23.065 26.8009 23.7487L22.4704 21.6345C22.467 21.1649 22.4689 20.695 22.4689 20.2258V18.7477L25.3147 16.4697C25.3185 16.4736 25.322 16.4775 25.3259 16.4814C26.0587 17.2216 27.2468 17.2216 27.9797 16.4814C28.7126 15.7412 28.7126 14.5411 27.9797 13.8009C27.2468 13.0607 26.0587 13.0607 25.3259 13.8009C24.671 14.4623 24.6019 15.4904 25.117 16.2298L22.2878 18.4942C22.2295 18.4626 22.1731 18.4263 22.1167 18.3916C21.9546 18.2918 21.7963 18.1857 21.6314 18.0905C21.4321 17.9759 21.2263 17.8733 21.0267 17.7594C20.8097 17.6354 20.5966 17.5052 20.3827 17.3757C20.2016 17.2661 20.022 17.1534 19.8409 17.0434C19.8332 17.0387 19.8255 17.0336 19.8181 17.0286V13.3559C21.2121 13.2752 22.3175 12.1083 22.3175 10.6801C22.3175 9.25191 21.129 8 19.6633 8C18.1976 8 17.0094 9.20004 17.0094 10.6805C17.0094 12.1609 18.1149 13.2752 19.5088 13.3563V17.0512C19.3714 17.1284 19.2328 17.2041 19.0968 17.284C18.8768 17.4143 18.6613 17.552 18.4416 17.6818C18.2732 17.7813 18.0987 17.869 17.9311 17.9696C17.789 18.0551 17.6562 18.1568 17.5137 18.2415C17.3516 18.3374 17.1855 18.4256 17.0206 18.5164L14.2714 16.2977C14.8394 15.5544 14.7865 14.483 14.1116 13.8017C13.3787 13.0615 12.1906 13.0615 11.4577 13.8017C10.7248 14.5419 10.7248 15.7419 11.4577 16.4822C12.1747 17.2064 13.3269 17.2216 14.0629 16.529L16.8558 18.7828C16.8569 19.7289 16.8565 20.6747 16.8589 21.6209L16.8453 21.5939L12.1157 23.9792C11.8187 23.496 11.2886 23.1742 10.6843 23.1742C9.75411 23.1742 9 23.9359 9 24.8754C9 25.8149 9.75411 26.5766 10.6843 26.5766C11.6145 26.5766 12.3686 25.8149 12.3686 24.8754C12.3686 24.6578 12.3276 24.4495 12.2539 24.2584L16.977 21.8767C17.0369 21.9141 17.0994 21.9477 17.1604 21.9836C17.377 22.1111 17.5937 22.2394 17.811 22.3654C17.9713 22.4586 18.1342 22.5463 18.2937 22.6407C18.3941 22.7004 18.4883 22.771 18.5887 22.8314C18.8694 23.0015 19.1528 23.1672 19.4335 23.3373C19.4583 23.3521 19.4834 23.3661 19.5088 23.3782V26.6449C18.1149 26.7256 17.0094 27.8925 17.0094 29.3207C17.0094 30.7489 18.1976 32.0012 19.6633 32.0012C21.129 32.0012 22.3171 30.8011 22.3171 29.3207C22.3171 27.8402 21.2117 26.726 19.8177 26.6449V23.3774C20.0228 23.269 20.2174 23.1399 20.4178 23.0233C20.5757 22.9317 20.7379 22.8478 20.8958 22.7561C21.0433 22.6707 21.1881 22.5799 21.3333 22.4902C21.4302 22.4301 21.5233 22.3622 21.6233 22.3076C21.8619 22.1774 22.104 22.0538 22.3434 21.9254C22.345 21.9247 22.3465 21.9235 22.348 21.9223L26.6657 24.0303C26.5618 24.2916 26.5039 24.5767 26.5039 24.8758C26.5039 26.1301 27.5106 27.1468 28.7523 27.1468C29.9941 27.1468 31.0008 26.1301 31.0008 24.8758C31.0008 23.6216 29.9941 22.6048 28.7523 22.6048L28.7527 22.604Z"
          fill="#F8F6F6"
        />
      </g>
      <defs>
        <clipPath id="clip0_4711_76011">
          <rect width="22" height="24" fill="white" transform="translate(9 8)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const PolyGPT = () => {
  const [t] = useTranslate()
  const dispatch = useDispatch()
  const [newChat, setNewChat] = useState(false)

  const [disclaimerVisible, setDisclaimerVisible] = useState(false)
  const [disclaimerAccepted, setDisclaimerAccepted] = useState(localStorage.getItem('poly-gpt-disclaimer-accepted') === 'true')

  const handleAcceptDisclaimer = () => {
    localStorage.setItem('poly-gpt-disclaimer-accepted', 'true')
    setDisclaimerVisible(false)
    setDisclaimerAccepted(true)
  }

  const { status: conversationsStatus, data: conversationsData } = useSelector((state: StoreState) => state.polyGpt.getConversations)
  // const [selectedTabKey, setSelectedTabKey] = useState<string>("history");

  // const [favoriteConversations, setFavoriteConversations] = useState<
  //   GPTConversation[]
  // >([]);

  const { status: conversationHistoryStatus } = useSelector((state: StoreState) => state.polyGpt.conversationHistory)
  const { status: conversationStatus } = useSelector((state: StoreState) => state.polyGpt.createConversation)

  useEffect(() => {
    if (conversationHistoryStatus === AsyncStates.SUCCESS) setNewChat(false)
  }, [conversationHistoryStatus])

  useEffect(() => {
    if (conversationsStatus === AsyncStates.SUCCESS) {
      if (conversationsData.conversations.length) {
        // const firstConversation = conversationsData.conversations[0];
        // dispatch(currentConversationSet(firstConversation));
        // dispatch(
        //   conversationHistoryRequest({
        //     conversation_id: firstConversation.conversation_id,
        //     page_size: 10,
        //     page_num: 1,
        //   })
        // );
      } else {
        setNewChat(true)
      }
    }
  }, [conversationsData.conversations, conversationsStatus])

  useEffect(() => {
    dispatch(getConversationsRequest())
  }, [dispatch])

  useEffect(() => {
    setDisclaimerVisible(localStorage.getItem('poly-gpt-disclaimer-accepted') !== 'true')
  }, [])

  return (
    <>
      {disclaimerAccepted && (
        <Space direction="vertical" size="large" className="gap-8" style={{ width: '100%' }}>
          <StyledPageHeader
            ghost={false}
            title={
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                {t('navBar.menuItem.aiEngine.polyGPT')}
                {/* <Tooltip title={t('common.betaTooltip')}>
                  <Tag color="processing">{t('common.beta')}</Tag>
                </Tooltip> */}
              </div>
            }
          />
          <StyledCard bodyStyle={{ padding: '8px 0px' }}>
            <Row style={{ height: '85vh', backgroundColor: '#ffffff' }}>
              <Col
                span={7}
                style={{
                  padding: '1rem',
                  background: '#FAFAFA'
                }}
              >
                <div style={{ textAlign: 'center', marginBottom: '0.5rem' }}>
                  <StyledButton
                    type="primary"
                    style={{ width: '100%' }}
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setNewChat(true)
                      dispatch(currentConversationClear())
                      dispatch(conversationHistoryClear())
                      dispatch(createConversationClear())
                      dispatch(getExtractionsClear())
                    }}
                    disabled={conversationStatus === AsyncStates.LOADING}
                  >
                    {t('polygpt.NewChat')}
                  </StyledButton>
                </div>
                {/* {conversationsStatus === AsyncStates.LOADING ? (
            <LoadingOutlined />
          ) : ( */}
                <GPTConversationList conversations={conversationsData.conversations} />
                {/* )} */}
                {/* <Tabs
            activeKey={selectedTabKey}
            onChange={(activeKey) => {
              setSelectedTabKey(activeKey);
            }}
          >
            <TabPane tab={"History"} key={"history"}>
              {conversationsStatus === AsyncStates.LOADING ? (
                <LoadingOutlined />
              ) : (
                <GPTConversationList
                  conversations={conversationsData.Conversations}
                />
              )}
            </TabPane>
            <TabPane tab={"Favorites"} key={"favorites"}>
              {conversationsStatus === AsyncStates.LOADING ? (
                <LoadingOutlined />
              ) : (
                <GPTConversationList
                  isFavourites={true}
                  conversations={conversationsData.Favourites}
                />
              )}
            </TabPane>
          </Tabs> */}
              </Col>
              <Col span={17} style={{ padding: '1rem' }}>
                <GptRightPanel chatStatus={[newChat, setNewChat]} />
              </Col>
            </Row>
          </StyledCard>
        </Space>
      )}
      <Modal
        title="Disclaimer"
        open={disclaimerVisible}
        // closable={false}
        maskClosable={false}
        footer={[
          <StyledButton key="understand" type="primary" onClick={handleAcceptDisclaimer}>
            {t('polygpt.disclaimer1')}
          </StyledButton>
        ]}
        onCancel={() => setDisclaimerVisible(false)}
      >
        <p>{t('polygpt.disclaimer2')}</p>
        <p>
          {t('polygpt.disclaimer3')}{' '}
          <a target="_blank" rel="noreferrer" href="https://openai.com/policies/terms-of-use">
            {' '}
            {t('polygpt.disclaimer4')}
          </a>
        </p>
      </Modal>
    </>
  )
}
